/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import NewsStories from './NewsStories';

/**
 * NewsStories module exports
 */
export { NewsStories as default };



// WEBPACK FOOTER //
// ./src/js/News/components/NewsStories/index.js